<template>
  <div id="footer" class="container-fluid">
    <div class="content">
      <div class="logo">
        <div class="left">
          <img v-if="$i18n.locale == 'en'" src="../assets/spec/logo-en.png" alt="logo图" style="margin-bottom: 30px">
          <img v-else src="../assets/spec/logo-w.png" alt="logo图" style="margin-bottom: 30px">
          <div class="line">
            <p><img src="../assets/img/location.png" alt="" class="img">{{ $t('information.in0') }}</p>
            <p><img src="../assets/img/phone.png" alt="" class="img">(0572)2577088 </p>
            <p><img src="../assets/img/mail.png" alt="" class="img">mail@cenlak.com</p>
          </div>
          <img src="../../src/assets/spec/wm.png" alt="">
        </div>
        <div class="right">
          <div class="line">
            <p>{{ $t('navbar.duty') }}</p>
          </div>
          <div class="line">
            <p>{{ $t('navbar.center') }}</p>
            <ul>
              <li @click="$router.push(item.route)" v-for="(item, index) in Productlist" :key="index">{{ item.title }}
              </li>
            </ul>
          </div>
          <div class="line">
            <p>{{ $t('navbar.advanced') }}</p>
          </div>
          <div class="line">
            <p>{{ $t('navbar.solve') }}</p>
            <ul>
              <li @click="$router.push(item.route)" v-for="(item, index) in CpList" :key="index">{{ item.title }}</li>
            </ul>
          </div>
          <div class="line">
            <p>{{ $t('navbar.about') }}</p>
            <ul>
              <li @click="$router.push(item.route)" v-for="(item, index) in aboutList" :key="index">{{ item.title }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="bottom">
        <!-- <p>Copyrigh © 2024 甚湖科技有限公司 版权所有<span>沪ICP备 04000001号</span></p> -->
        <p class="keep-spaces ">
          Copyrigh © 2024 甚湖科技有限公司 版权所有
          <span><a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank"
              class="color-f">浙ICP备2024138185号</a></span>
          <span class="beian">
            <img class="resentImg" src="../assets/img/copyrigh.png" alt="logo图" />
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=33050202001669" rel="noreferrer"
              target="_blank">浙公网安备33050202001669号</a>
          </span>

        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      isEn: true,
    }
  },
  created() {
    console.log('当前语言是222', this.$i18n.locale);
    if (this.$i18n.locale === 'zh') {
      this.isEn = false;
    } else {
      this.isEn = true;
    }
  },
  computed: {

    Productlist() {
      return [
        {
          title: this.$t('prod.save'),
          route: '/soft'
        },
        {
          title: this.$t('newli.lu9'),
          route: '/GENRE'
        },
        {
          title: this.$t('newli.lu14'),
          route: '/store'
        },
      ]
    },
    CpList() {
      return [
        {
          title: this.$t('solution.bl1'),
          route: '/product/Solution/PC'
        },
        {
          title: this.$t('solution.bl2'),
          route: '/product/Solution/Datacenter'
        },
        {
          title: this.$t('solution.bl3'),
          route: '/product/Solution/Terminal'
        },
        {
          title: this.$t('solution.bl4'),
          route: '/product/Solution/CAR'
        },
        {
          title: this.$t('solution.bl5'),
          route: '/product/Solution/Mobile'
        },
        {
          title: this.$t('solution.bl6'),
          route: '/product/Solution/Industry'
        },
      ]
    },
    aboutList() {
      return [
        {
          title: this.$t('aboutList.ab1'),
          route: '/companyintroduction'
        },
        {
          title: this.$t('aboutList.ab3'),
          route: '/core'
        },
        {
          title: this.$t('aboutList.ab4'),
          route: '/Classic'
        },
        {
          title: this.$t('aboutList.ab5'),
          route: '/news'
        },
        {
          title: this.$t('aboutList.ab7'),
          route: '/jobchance'
        },
        {
          title: this.$t('aboutList.ab8'),
          route: '/contactus'
        },
      ]
    }
  },
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: auto;
  color: #fff;
  background: black;
  overflow: hidden;
}

#footer .content {
  width: 1170px;
  margin: 0 auto;
}

#footer .content .left .line p {
  margin-bottom: 20px;
}

#footer .content .right {
  display: flex;
  justify-content: space-between;
}

#footer .content .right .line {
  margin-right: 50px;
}

#footer .content .right .line p {
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 22px;
  margin-bottom: 32px;
}

#footer .content .right .line li {
  cursor: pointer;
  margin-bottom: 20px;
  font-weight: 400;
  font-size: 16px;
  color: #B2B6BB;
  line-height: 22px;
}

#footer .line .img {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: middle;
}

.logo {
  display: flex;
  justify-content: space-between;
  padding: 50px 0;
  margin: 0 auto;
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
}

.bottom {
  margin-top: 20px;
  flex: 1;
}

.bottom p {
  height: 100%;
  display: flex;
  align-items: center;
  color: white;
}

.bottom p span {
  padding-left: 20px;
}

@media screen and (max-width: 1170px) {
  #footer {
    height: auto;
  }

  #footer .content {
    width: 100%;
  }

  #footer .left img {
    margin: 0 auto;
  }

  #footer .left .line {
    margin: 0 auto;
    text-align: center;
  }

  #footer .right {
    display: none !important;
  }

  #footer .logo {
    display: flex;
    justify-content: center;
  }
}

@media screen and (max-width: 997px) {
  #footer {
    height: auto;
  }

  #footer .right {
    display: none !important;
  }
}

.keep-spaces {
  white-space: break-spaces;
}

.color-f {
  color: #fff;

}

.resentImg {
  width: 13px;
}

.beian {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue